<template>
  <div style="height: 100%;">
    <signin
      v-if="currentView==='signin'"
      @closeModal="closeModal"
      @changeView="changeView"
    ></signin>
    <chooseauth
      v-if="currentView==='chooseauth'"
      @closeModal="closeModal"
      @changeView="changeView"
    ></chooseauth>
    <passwordreset
      v-if="currentView==='passwordreset'"
      @closeModal="closeModal"
      @changeView="changeView"
    ></passwordreset>
  </div>
</template>

<script>
import chooseauth from './chooseauth.vue'
// import signin from './signin.vue'
// import passwordreset from './passwordreset.vue'
const signin = () => import('./signin.vue')
const passwordreset = () => import('./passwordreset.vue')

export default {
  props: {
    defaultView: {
      type: String,
      default: 'chooseauth'
    }
  },
  data() {
    return {
      currentView: this.defaultView,
    }
  },
  components: {
    signin,
    chooseauth,
    passwordreset
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
      this.changeView(this.defaultView)
    },
    changeView(view) {
      this.currentView = view
    }
  }
}
</script>